
<span class="absolute right-1 top-1/2 -translate-y-1/2 inline-block px-2 py-1 font-semibold leading-tight">
    <span aria-hidden class="absolute inset-0 rounded-full bg-mango-red707"></span>
    <span class="relative flex text-white sm:text-[11px]">{{ displayCount }}</span>
</span>